import {
  AKA_FAMILY_ACCIDENT_ABOUT_INSURANCE_STEP,
  AKA_FAMILY_ACCIDENT_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/AkaFamilyAccident/akaFamilyAccidentSteps";

import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";

export function mapFromCommerceAkaFamilyAccident(
  data: Record<string, any>,
): FormStates {
  return {
    [AKA_FAMILY_ACCIDENT_ABOUT_INSURANCE_STEP.id]: {
      hasDeathCoverage: data.hasDeathCoverage,
      hasDisabilityCoverage: data.hasDisabilityCoverage,
      hasProfessionalDisabilityCoverage: data.hasProfessionalDisabilityCoverage,
    },
    [AKA_FAMILY_ACCIDENT_PRICE_STEP.id]: {
      coverage: data.coverageGroup,
      hasDeathCoverage: data.hasDeathCoverage,
      hasDisabilityCoverage: data.hasDisabilityCoverage,
      hasProfessionalDisabilityCoverage: data.hasProfessionalDisabilityCoverage,
    },
  };
}
